// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"734":"a8ae327b","3952":"a8ae327b","4385":"a8ae327b"}[chunkId] + ".chunk.css";
};